export default {
  platformRow1: 'JWI cloud platform is based on cloud native (Cloud Native) architecture developed to manage enterprise-level application industrial software or enterprise digital PAAS platform, the main features are as follows:',
  platformRow2: 'Service: service governance and provision of standardized service components;',
  platformRow3: 'Open-loop environment: Provide rapid development and delivery application environment support;',
  platformRow4: 'DevOps: continuous integration/continuous deployment process management environment;',
  platformRow5: 'Automated O&M: Supported by automated O&M tools for applications, containers, and hardware environments.'
}
